import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { Collapse, Card, CardBody, Input, Label } from "reactstrap";
import { quickReplyLoadAll, quickReplySetCount, addMessage2s } from "../../../../redux/actions";
import * as urls from "../../../../api/urls";
import classnames from "classnames";
// swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import TextBox from "components/TextBox";
import AppSimpleBar from "components/AppSimpleBar";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import { QuickReplyContentTypes } from "const";

interface QuickReplyProps {
  // images: { blobUrl: string; file: File; index: number }[];
  // onRemoveImage: (index: number) => void;
  isOpen: boolean;
  onSendDone: () => void;
}
const QuickReply = ({ isOpen, onSendDone }: QuickReplyProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Chats,
    (chat) => ({
      quickReplies: chat.quickReplies ?? [],
      selectedChat: chat.selectedChat,
    })
  );
  const { quickReplies, selectedChat } = useAppSelector(storeData);
  const [filter, setFilter] = useState<string>("");
  const [qData, setQData] = useState<any>(null);

  useEffect(() => {
    if (!quickReplies || quickReplies.length <= 0) {
      // console.log('reload quick reply item');
      dispatch(quickReplyLoadAll());
    }
  }, []);

  const myRef = useRef<any>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const target = event.target as HTMLElement;
      // let clickOnToggle = false;
      // if (target && target.classList.contains("fa-rocketchat")) { // click on toggle button
      //   clickOnToggle = true;
      // }
      const clickedToggle = target.closest('.fa-rocketchat') !== null;
      const clickedSweetAlert = target.closest('.swal2-container') !== null;
      if (clickedToggle || clickedSweetAlert) return;
      if (
        myRef.current &&
        !myRef.current.contains(event.target as Node)
      ) {
        onSendDone();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  const onRefresh = () => {
    dispatch(quickReplyLoadAll());
  }
  const onClickItem = (quickReplyId: number) => {
    try {
      const api = new APIClient();
      api.fnPostForm(urls.QUICK_REPLY_LOAD, { quickReplyId: quickReplyId })
        .then(rs => {
          setQData(rs);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
        });

    } catch (e) {
      Utils.HandleException(e, true);
    }
  }
  const convert2Html = (quickItem: any) => {
    const itm = quickItem;
    const value = itm.contents;
    const text = itm.contentName ?? value;
    switch (quickItem.contentType) {
      case QuickReplyContentTypes.Text: return `${value}`;
      case QuickReplyContentTypes.File: return `<a href="${value}" target="_blank">${text}</a>`;
      case QuickReplyContentTypes.Link: return `<a href="${value}" target="_blank">${text}</a>`;
      case QuickReplyContentTypes.Picture: return `<img src="${Utils.ConvertUrlIfItIsInternalChat(value)}" stk-src="${value.replaceAll("thumb_/", "")}" class="chat-sticker-img"/>`;
      case QuickReplyContentTypes.Sticker: return `<img src="${value}" class="chat-sticker"/>`;
    }
    return "";
  }

  const divPrevRef = useRef<any>(null);
  const divForSendRef = useRef<any>(null);

  const onSendStickerToChat = (quickReplyId: number) => {
    try {
      if (!selectedChat) {
        alert('ยังไม่ได้เลือกห้องแชท');
        return;
      }
      if (!divForSendRef.current) {
        alert('ไม่มี content');
        return;
      }

      let text = divForSendRef.current.innerText;
      // if (text == '') text = "ข้อความใหม่";
      const html = divForSendRef.current.innerHTML;
      const msgId = Utils.GetUniqueId();
      const parm = {
        msgId: msgId,
        groupId: selectedChat,
        text: text,
        htmlContent: html,
        quickReplyId: quickReplyId
      }
      // console.log('parm:', parm);

      dispatch(addMessage2s({
        mId: msgId,
        text: text,/*message.text,*/
        tagNames: null,
        isFromMe: true,
        time: Utils.GetCurrentDateTimeLongFormat(),
        senderName: "xxx",
        senderImg: '',
        meta: {
          receiver: selectedChat,
          sender: -1,
          senderName: "dummy",
          sent: false,
          received: false,
          read: false,
          isForwarded: false,
          userData: null
        },
        // conversationId: -1,
        conversationId: selectedChat, // 20261020: real room id -> reducer can keep it out of another room's list
        conversion: null,
        replyOf: null,
      }, 'I Add'));

      const api = new APIClient
      api.fnPostForm(urls.SEND_QUICK_REPLY_TO_CHAT, parm)
        .then(rs => {
          // console.log('rs:', rs);
          dispatch(quickReplySetCount(rs.quickReplyId, rs.count));
          onSendDone();
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
        });

    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onEditItem = (item: any) => {
    try {
      // console.log('click edit:', item);
      const content = item.contents?.replaceAll("<br/>", "\n");
      Utils.SweetTextArea('แก้ไขข้อคามที่คุณต้องการเปลี่ยน', content)
        .then(rs => {
          if (rs) {
            const rsHtml = rs.replaceAll("\n", "<br/>");
            // console.log({ qData, rs });
            setQData((data: any) => ({
              ...data,
              items: data.items?.map((itm: any) => itm.seq === item.seq ? ({ ...itm, contents: rsHtml }) : itm)
            }));
            // console.log({ qData, rs });
          }
        });
    } catch (e) {
      Utils.HandleException(e, true);
    }

  }

  return (
    <Collapse
      isOpen={isOpen}
      className="chat-input-collapse chat-input-quickreply"
      id="chatinputquickreplycollapse"
    >
      <div ref={myRef}>
        <Card className="mb-0" style={{ backgroundColor: "var(--m2-bgcolor-accordion-button)" }}>
          <CardBody className="p-2 d-flex justify-content-between" style={{ gap: "15px" }}>
            <div>
              <TextBox className="form-control p-1 mb-2" placeholder="กรอง" icon13small={true} icon13css="fa fa-refresh" onEnter13={onRefresh} value={filter} onChange={(e) => setFilter(e.target.value)} />
              <AppSimpleBar className="chat-input-quickreply-list">
                <div className="d-flex flex-column" style={{ gap: "4px" }}>
                  {[...quickReplies].filter(e => Utils.IsMatchAll(e.keywords, filter)).sort((e1, e2) => e2.count - e1.count).map((item, index) => {
                    return (
                      <div key={index}
                        className={classnames("dset-qr-cat hover hand d-flex justify-content-between align-items-center", { "active-primary": false })}
                        onClick={() => onClickItem(item.quickReplyId)}
                      >
                        <div style={{ flex: "1" }} >
                          {item.name}
                        </div>
                        <div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </AppSimpleBar>
            </div>
            <div className="" style={{ flex: "1" }}>
              <div className="chat-input-quickreply-prev" style={{ height: "390px", overflow: "auto", border: "solid 1px var(--m2-border-tag-color) !important" }}>
                <div ref={divPrevRef} className="p-2" >
                  {(qData ?? {}).items?.map((item: any, index: number) => {
                    return (
                      <div
                        className={classnames({ "hover hand": item.contentType === QuickReplyContentTypes.Text })}
                        onClick={() => item.contentType === QuickReplyContentTypes.Text ? onEditItem(item) : null}
                        dangerouslySetInnerHTML={{ __html: convert2Html(item) }}>
                      </div>
                    )
                  })}
                </div>

                <div ref={divForSendRef} className="p-2" style={{ display: "none" }} >
                  <div style={{ textAlign: "left" }} >
                    {(qData ?? {}).items?.map((item: any, index: number) => {
                      return (
                        <div
                          className={classnames({ "": item.contentType === QuickReplyContentTypes.Text })}
                          dangerouslySetInnerHTML={{ __html: convert2Html(item) }}>
                        </div>
                      )
                    })}
                  </div>
                </div>

              </div>
              <div className="d-flex justify-content-between mt-2">
                &nbsp;
                {(qData ?? {}).items?.length > 0 && (
                  <button className="btn btn-pc btn-primary" onClick={() => onSendStickerToChat(qData.quickReplyId)}>ส่งข้อความ</button>
                )}
              </div>
            </div>




          </CardBody>
        </Card>
      </div>
    </Collapse>
  );
};

export default QuickReply;
